import { connect } from 'react-redux'
import SubValuationFooter from './SubValuationFooter'

const mapStateToProps = (state) => ({
})

const actionCreators = {
}

export default connect(mapStateToProps, actionCreators)(SubValuationFooter)
